import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { HostService } from './host.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private getHost: HostService, private http: HttpClient) { }

  index(object: Object) {
    return this.http
      .post<any[]>(this.getHost.gethttps() + "dashboard", object);
  }

  profitCurrentYear(obj: Object) {

    return this.http.post(this.getHost.gethttps()+ "profitCurrentYear", obj);

  }
}
